// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2173":"96e9759f","8369":"453278a4","8543":"b6428dc2","9444":"9c26201d","9578":"d5b19b6d"}[chunkId] + ".chunk.css";
};